import { SYSTEM_LIMITS } from 'common';
import { Controller, useFieldArray } from 'react-hook-form';
import Button from 'style-guide/Button';
import { Plus, Trash } from 'style-guide/Icons';
import { Input } from 'style-guide/Input';
import Text from 'style-guide/Typography/Text';
import LikertScaleWrapper from './style/LikertScaleWrapper';

const {
  COURSE_SECTIONS: { TESTS },
} = SYSTEM_LIMITS;

const LikertScale = ({ control }) => {
  const { fields, remove, append } = useFieldArray({
    control,
    name: 'answer',
  });

  return (
    <LikertScaleWrapper>
      <Text $variant={2}>*You can customize the labels for the options, with a maximum of 5 options</Text>
      {fields.length < 5 && (
        <Button
          variant='link'
          prefix={<Plus width={16} height={16} />}
          className='mt--12'
          onClick={() => append({ answer: '' })}
        >
          Add New Option
        </Button>
      )}
      <div className='mt--16'>
        {fields.map((field, index) => (
          <div key={field.id} className='d-flex align-items-center'>
            <Controller
              control={control}
              name={`answer.${index}.answer`}
              render={({ field: answerField }) => (
                <Input maxLength={TESTS.likertScale.max} {...answerField} className='likert-scale-input mr--8' />
              )}
            />
            {fields.length > TESTS.ANSWER.LIST.min ? (
              <Button variant='text' $danger onClick={() => remove(index)}>
                <Trash />
              </Button>
            ) : null}
          </div>
        ))}
      </div>
    </LikertScaleWrapper>
  );
};

export default LikertScale;
